<template>
	<div>

		<div class="vx-row pt-1 pb-1">
			<div class="vx-col w-full">
				<vs-divider color="primary" border-style="dotted" position="right">Totalen</vs-divider>
			</div>
		</div>

		<div class="vx-row" >
			<div class="vx-col w-4/12" >
				<img v-if="order.order.type === 1" src="@/assets/images/orders/types/bol.png" alt="content-img" style="max-height: 50px; position: absolute; bottom: 10px;
				left:30px">
				<img v-if="order.order.type === 2" src="@/assets/images/orders/types/lightspeed.png" alt="content-img" style="max-height: 50px; position: absolute; bottom: 10px;
left: 30px">
			</div>
			<div class="vx-col w-8/12" >
				<div class="vx-row">
					<div class="vx-col w-full pr-5">
						<div class="flex h-full items-center float-right">
							<vx-tooltip text="Totale waarde bestelling">
								Bestelling totaal: €{{order.order.order_price}}
							</vx-tooltip>
						</div>
					</div>
				</div>
				<div class="vx-row">
					<div class="vx-col w-full pr-5">
						<div class="flex h-full items-center float-right">
							<vx-tooltip text="Totale bemiddelingsbijdrage">
								Bemiddelingsbijdrage: -€{{ (this.totalTransactionFee).toFixed(2) }}
							</vx-tooltip>
						</div>
					</div>
				</div>

				<div class="vx-row">
					<div class="vx-col w-full pr-5">
						<div class="flex h-full items-center float-right text-xl">
							<vx-tooltip text="Totale marge bestelling">
								<b>€{{ (this.totalMarge).toFixed(2) }}</b>
							</vx-tooltip>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		order: {
			type: Object,
			required: true
		},
		totalTransactionFee: {
			type: Number,
			required: true
		},
		totalMarge: {
			type: Number,
			required: true
		},
	}
}
</script>
